/* onload javascript */
if(!bodyElement) var bodyElement = document.querySelector("body");

/* Add hidden to all topbars */
document.querySelectorAll(".topbar").forEach(el=>{
  el.setAttribute("hidden", true);
});

/* Add page dimensions element to page */
Barracuda.createStats();
window.addEventListener("resize",Barracuda.createStats);

/* Define scrollbar width and height */
Barracuda.setScrollBarWidth();

/* Listen for escape key and if, then close overlay window */
document.addEventListener('keydown', function(event){
	if(event.key === "Escape" && document.querySelector("body.show-overlay"))
      overlayClick(null, true);
});

/* scroll actions */
var lastPosition = 0;
window.addEventListener("scroll", () => {
   if (window.scrollY < lastPosition - 10 || window.scrollY > lastPosition + 10) {
     if (window.scrollY < lastPosition - 10) {
       bodyElement.classList.add("scroll-top");
     }
      else bodyElement.classList.remove("scroll-top");

      if (window.scrollY > lastPosition + 10) bodyElement.classList.add("scroll-down");
      else bodyElement.classList.remove("scroll-down");

      if (window.scrollY <= 0) bodyElement.classList.add("scroll-on-top");
      else bodyElement.classList.remove("scroll-on-top");

      if (window.scrollY != 0 && window.scrollY < 10) bodyElement.classList.add("scroll-after-top");
      else bodyElement.classList.remove("scroll-after-top");

      var headerHeight = document.querySelector("#header-sections").offsetHeight;
     if (window.scrollY > headerHeight) {
       if(!bodyElement.classList.contains("after-header")){
       bodyElement.classList.add("after-header");
         setTimeout(function () { bodyElement.classList.add("after-header-2") }, 10);
       }
     }
      else bodyElement.classList.remove("after-header","after-header-2");

      if ((window.innerHeight + window.scrollY + 100 ) >= bodyElement.offsetHeight) bodyElement.classList.add("on-bottom");
      else bodyElement.classList.remove("on-bottom");

      lastPosition = window.scrollY;
   }
});

/* Cookies bar */
if(getCookie('cookie-bar') != "confirm"){
  var el = document.querySelector("#cookies-bar");
  if (el){
    el.classList.remove("hide");
    el.querySelector("#cookies-bar-confirm-button").addEventListener("click",()=>{
      setCookie("cookie-bar","confirm",120);
      Barracuda.fadeOut(el,()=>{
        el.classList.add("hide");
    }, (Barracuda.duration * 2));
    },false);
  }
}
      
/* Product-recommendations load */
Barracuda.loadRecommendations = function (){
  var placeholder = document.querySelector(".product-recommendations-not-loaded");
  var placeholder_parent = document.querySelector(".product-recommendations:not(.initialized)");
  if(placeholder && placeholder_parent){
    placeholder_parent.classList.add("initialized");
    axios.get(Shopify.routes.root+'recommendations/products', {
      params: {
        section_id: placeholder.dataset.sectionid,
        "limit": 4,
        product_id: parseInt(placeholder.dataset.productid)
      }
    })
    .then(function (response) {
      var code = response.data;
      var ajaxElement = document.createElement("DIV");
      ajaxElement.innerHTML = code;
      placeholder_parent.innerHTML += ajaxElement.querySelector(".product-recommendations").innerHTML;
      placeholder.remove();
      Barracuda.init();
      Barracuda.elements.init();
      Barracuda.setScrollBarWidth();
    })
    .catch(function (error) {
      console.log(error);
    })
  }
}

/* Predefine Barracuda objects (Custom elements) */
Barracuda.elements = {}
Barracuda.elements.SlideshowObjects = {};
Barracuda.elements.Counts = [];
Barracuda.elements.AjaxForms = [];
Barracuda.elements.Maps = [];
Barracuda.elements.Products = [];
Barracuda.elements.Overlapping = {}
Barracuda.elements.lazyVideos = [];
Barracuda.elements.lazyMaps = [];
Barracuda.elements.richMedia = {};

if(document.querySelector(".main-menu"))
  Barracuda.elements.mainMenu = new BarracudaAnimatedMenu();


Barracuda.elements.init = function (){
  /* Load recommendations */
  Barracuda.loadRecommendations();

  /* Barracuda overlapping */
  Barracuda.elements.Overlapping = new BarracudaOverlapping();

  /* Barracuda gallery v3 */
  if (document.readyState === "complete") document.querySelectorAll("barracuda-product-gallery").forEach((el) => {el.init();});

  /* Barracuda slideshow */
  document.querySelectorAll(".barracuda-slideshow:not(.barracuda-slideshow-initialized)").forEach(el=>{
      Barracuda.elements.SlideshowObjects[el.id] = new BarracudaSlideshow(el);
  })

  /* Barracuda forms */
  document.querySelectorAll(".use-barracuda-count:not(.use-barracuda-count-initialized)").forEach(element=>{
    Barracuda.elements.Counts.push(new BarracudaCount(element))
  });

  /* Barracuda ajax form */
  document.querySelectorAll(".use-barracuda-ajax-form:not(.use-barracuda-ajax-form-initialized)").forEach(element=>{
    Barracuda.elements.AjaxForms.push(new BarracudaAjaxForm(element))
  });

  /* Barracuda lazy-map */
  document.querySelectorAll(".lazy-map:not(.lazy-map-initialized)").forEach(element=>{
    element.classList.add("lazy-map-initialized")
    Barracuda.elements.lazyMaps.push(element)
  })

  /* Barracuda product form - variants */
  document.querySelectorAll(".barracuda-product:not(.barracuda-product-initialized)").forEach(element=>{
    Barracuda.elements.Products.push(new BarracudaProduct(element))
  });

  /* Barracuda lazy-video */
  document.querySelectorAll(".lazy-video:not(.lazy-video-initialized)").forEach(element=>{
    element.classList.add("lazy-video-initialized")
    Barracuda.elements.lazyVideos.push(element)
  })

  /* Barracuda Rich media (video, 3D)*/
  document.querySelectorAll(".barracuda-richmedia:not(.barracuda-richmedia-initialized)").forEach(element=>{
    element.classList.add("barracuda-richmedia-initialized")
    if(element.dataset.mediaid && !Barracuda.elements.richMedia[element.dataset.mediaid]){
      Barracuda.elements.richMedia[element.dataset.mediaid] = new BarracudaRichMedia(element);
    }else{
      if(!element.dataset.mediaid)
        console.error("Barracuda: Rich media need a defined dataset.mediaid", element);
    }
  })

  /* Barracuda select */
  document.querySelectorAll(".barracuda-select:not(.barracuda-select-initialized)").forEach(element=>{
    element.classList.add("barracuda-select-initialized");
    var def_val = element.querySelector("select")? element.querySelector("select").dataset.default : false;
    if(def_val)
      element.querySelectorAll("option").forEach((value, key) => {
        if(value.innerText == def_val){
          element.querySelector("select")? element.querySelector("select").selectedIndex = ""+key : false;   
        }
      })
  });

  /* Product-lightbox load */
  document.querySelectorAll(".use-product-lightbox:not(.use-product-lightbox-initialized)").forEach(el=>{
    el.classList.add("use-product-lightbox-initialized");
    el.addEventListener("click", (e) => {
      if (!e.target.closest(".prevent-quickview")){
        prevent(e);
        let openButton = e.target.closest(".button");
        if (openButton) openButton.classList.add("loading")
        var currentContent = document.querySelector(".overlay-content-content>form, .overlay-content-content>div");
        if (currentContent && currentContent.dataset.source) {
          var t = document.querySelector("#" + currentContent.dataset.source);
          if (t) t.appendChild(currentContent);
        }
        let content = document.querySelector(".overlay-content");
        content.innerHTML = "";
        content.classList.add("loading")
        lockBodyPosition();
        let url = el.dataset.product ? el.dataset.product + (el.dataset.product.includes("?") ? '&sections=product-lightbox' : '?sections=product-lightbox') : false;
        axios.get(url ? url : '/products/?sections=product-lightbox')
          .then(function (response) {
            var code = response.data ? (response.data['product-lightbox'] ? response.data['product-lightbox'] : false) : false;
            if (code) {
              content.classList.remove("loading")
              content.innerHTML = code;
              Barracuda.elements.init();
              barracudaCart.appendAddToCartButton(document.querySelector(".overlay-content").querySelector(".barracuda-cart-addToCartButton"));
              document.querySelector("body").classList.add("show-overlay");
            }
            if (openButton) openButton.classList.remove("loading")
          })
          .catch(function (error) {
            unlockBodyPosition();
            console.log(error);
            if (openButton) openButton.classList.remove("loading")
          });
        return false;
      }
    },false)
  });

  /* Barracuda search  */
  if(document.querySelector(".barracuda-search-input:not(.initialized)")){
    document.querySelector(".barracuda-search-input").classList.add("initialized");
    var search = new BarracudaSearch(
        document.querySelector(".barracuda-search-input"),
        document.querySelector(".barracuda-search-submit"),
        document.querySelector(".barracuda-search-close"),
        document.querySelector(".barracuda-search-target")
        );
  }

  if(document.querySelector(".barracuda-search-page-input:not(.initialized)")){
    document.querySelector(".barracuda-search-page-input").classList.add("initialized");
    var searchPage = new BarracudaSearch(
      document.querySelector(".barracuda-search-page-input"),
      document.querySelector(".barracuda-search-page-submit"),
      document.querySelector(".barracuda-search-page-close"),
      document.querySelector(".barracuda-search-page-target")
    );
  }
}


/* Barracuda cart */
if(typeof BarracudaCart !== 'undefined')
  var barracudaCart = new BarracudaCart(
    document.querySelector(".barracuda-cart-opener"),
    document.querySelector(".barracuda-cart-target"),
    document.querySelector("#page-content>div.main-cart-content")
  )

/* Initial barracuda Objects */
Barracuda.elements.init();
/* Inicialize for Dynamic elements */
Barracuda.init();

/* Filtr popup dots */
Barracuda.checkFilter = function (e){
  var filter = e.target.closest(".filter-line");
  if(filter.querySelector("input:checked")){
    filter = filter.querySelector(".inactive-filter:not(.active-filter)")
    if( filter)
      filter.classList.add("active-filter");
  }else{
    filter = filter.querySelector(".inactive-filter.active-filter")
    if( filter)
      filter.classList.remove("active-filter");
  }
}